import http from '@/shared/api/http'

export const ORDER_STATUSES = [
  'Новая',
  'В работе',
  'Доставка',
  'Оплачено/Закрыта',
  'Неоплачена/Закрыта'
]

export async function createOrderFromCart(cartId) {
  return http.post(`/orders/create-from-cart/${cartId}`)
}

export async function getMyOrders() {
  return http.get('/orders')
}

export async function getOrderById(orderId) {
  return http.get(`/orders/${orderId}`)
}

export async function getAllOrdersForAdmin() {
  return http.get('/orders/admin/all')
}

export async function updateOrderStatus(orderId, status) {
  return http.patch(`/orders/${orderId}/status`, { status })
}

export async function assignOrder(orderId) {
  return http.post(`/orders/${orderId}/assign`)
}